import { createContext, useContext, useState, useEffect, useCallback } from "react";
import clientApi from "@/lib/clientApi";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(undefined); // undefined = loading, null = logged out

  useEffect(() => {
    const token = localStorage.getItem("hm_client_token");
    if (!token) { setClient(null); return; }
    clientApi.get("/client/me").then((r) => setClient(r.data)).catch(() => {
      localStorage.removeItem("hm_client_token");
      setClient(null);
    });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await clientApi.post("/client/login", { email, password });
    localStorage.setItem("hm_client_token", data.token);
    setClient(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (name, email, password, preferredLanguage = "en", profile = {}) => {
    const { data } = await clientApi.post("/client/register", {
      name, email, password, preferred_language: preferredLanguage,
      referral_code: localStorage.getItem("hm_ref") || undefined,
      ...profile,
    });
    localStorage.setItem("hm_client_token", data.token);
    setClient(data.user);
    return data.user;
  }, []);

  const updateClient = useCallback((patch) => setClient((c) => (c ? { ...c, ...patch } : c)), []);

  const logout = useCallback(() => {
    localStorage.removeItem("hm_client_token");
    setClient(null);
  }, []);

  return (
    <ClientAuthContext.Provider value={{ client, login, register, logout, updateClient }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
